import type { ClientTransport } from "@alinq/sdk";
import type { RelayServerMessage } from "@alinq/proto";

/**
 * ClientTransport over a browser WebSocket. Buffers messages until the SDK client
 * registers its handler, so the relay's immediate auth.challenge is never missed.
 */
export function browserWsTransport(relayUrl: string): ClientTransport {
  const ws = new WebSocket(relayUrl);
  let handler: ((m: RelayServerMessage) => void) | undefined;
  const buffer: RelayServerMessage[] = [];
  const outbox: string[] = [];
  let open = false;

  ws.addEventListener("open", () => {
    open = true;
    for (const frame of outbox.splice(0)) ws.send(frame);
  });
  ws.addEventListener("message", (ev) => {
    const m = JSON.parse(String(ev.data)) as RelayServerMessage;
    if (handler) handler(m);
    else buffer.push(m);
  });

  return {
    send: (m) => {
      const frame = JSON.stringify(m);
      if (open) ws.send(frame);
      else outbox.push(frame);
    },
    onMessage: (h) => {
      handler = h;
      while (buffer.length) h(buffer.shift()!);
    },
    close: () => ws.close(),
  };
}
